import { useEffect } from "react";
import { navigate } from "gatsby";
import { normalizePathWithTrailingSlash } from "../../utils/url";

const TrailingSlashHandler = ({ location }) => {
  useEffect(() => {
    const pathname = location?.pathname || "/";
    if (pathname === "/" || pathname.endsWith("/")) return;

    const normalizedPath = normalizePathWithTrailingSlash(pathname);
    const search = location?.search || "";
    const hash = location?.hash || "";
    const target = `${normalizedPath}${search}${hash}`;

    navigate(target, { replace: true });
  }, [location?.pathname, location?.search, location?.hash]);

  return null;
};

export default TrailingSlashHandler;
